import type {
  AccessorialSchedule,
  AccessorialScheduleListItem,
} from "../../hooks/react-query/backOffice/useAccessorialSchedules";

// Mock data for list view (matches AccessorialScheduleListItem type)
export const mockAccessorialSchedulesListItems: AccessorialScheduleListItem[] =
  [
    {
      id: 1,
      name: "Standard Schedule",
      description: "Standard accessorial charges schedule",
      numberOfAccessorialCharges: 3,
      status: "Active",
    },
    {
      id: 2,
      name: "Premium Schedule",
      description: "Premium tier accessorial charges",
      numberOfAccessorialCharges: 5,
      status: "Active",
    },
    {
      id: 3,
      name: "Express Schedule",
      description: "Express delivery accessorial charges",
      numberOfAccessorialCharges: 2,
      status: "Draft",
    },
    {
      id: 4,
      name: "Economy Schedule",
      description: "Economy tier accessorial charges",
      numberOfAccessorialCharges: 4,
      status: "Active",
    },
    {
      id: 5,
      name: "Special Handling Schedule",
      description: "Special handling requirements charges",
      numberOfAccessorialCharges: 6,
      status: "Inactive",
    },
    {
      id: 6,
      name: "Holiday Schedule",
      description: "Holiday period accessorial charges",
      numberOfAccessorialCharges: 3,
      status: "Draft",
    },
    {
      id: 174,
      name: "Test Schedule 174",
      description: "Test schedule for development",
      numberOfAccessorialCharges: 2,
      status: "Active",
    },
  ];

// Mock data for detail view (matches AccessorialSchedule type)
export const mockAccessorialSchedules: AccessorialSchedule[] = [
  {
    id: 1,
    name: "Standard Schedule",
    description: "Standard accessorial charges schedule",
    accessorialChargeCount: 3,
    status: "Active",
    createdBy: "John Doe",
    createdDate: "2025-01-15",
  },
  {
    id: 2,
    name: "Premium Schedule",
    description: "Premium tier accessorial charges",
    accessorialChargeCount: 5,
    status: "Active",
    createdBy: "Jane Smith",
    createdDate: "2025-01-10",
  },
  {
    id: 3,
    name: "Express Schedule",
    description: "Express delivery accessorial charges",
    accessorialChargeCount: 2,
    status: "Draft",
    createdBy: "Carlos Mendez",
    createdDate: "2025-01-20",
  },
  {
    id: 4,
    name: "Economy Schedule",
    description: "Economy tier accessorial charges",
    accessorialChargeCount: 4,
    status: "Active",
    createdBy: "Sarah Johnson",
    createdDate: "2025-01-05",
  },
  {
    id: 5,
    name: "Special Handling Schedule",
    description: "Special handling requirements charges",
    accessorialChargeCount: 6,
    status: "Inactive",
    createdBy: "Michael Brown",
    createdDate: "2024-12-28",
  },
  {
    id: 6,
    name: "Holiday Schedule",
    description: "Holiday period accessorial charges",
    accessorialChargeCount: 3,
    status: "Draft",
    createdBy: "Emily Davis",
    createdDate: "2025-01-18",
  },
  {
    id: 174,
    name: "Test Schedule 174",
    description: "Test schedule for development",
    accessorialChargeCount: 2,
    status: "Active",
    createdBy: "Test User",
    createdDate: "2025-01-23",
  },
];

export const mockAddedAccessorialCharges = [
  {
    id: 1,
    code: "BlindFee",
    description: "Blind Shipment Fee",
    longDescription: "Blind Shipment Fee",
    serviceLevel: ["LTL"],
    rateConfiguration: "Flat Rate",
    rateMinMax: "$1,699",
    appliesTo: "Pickup",
    accessorialType: "Global",
    status: "Active",
    autoAssign: "No",
    currency: "USD",
    createdDate: "11/5/2025",
    createdBy: "Carlos Mendez",
    shippingInstructionsCode: "1234",
    interlinerCharges: "No",
  },
  {
    id: 2,
    code: "BlindFee2",
    description: "Blind Shipment Fee",
    longDescription: "Blind Shipment Fee 2",
    serviceLevel: ["FTL"],
    rateConfiguration: "Multiple Rates",
    rateMinMax: "Pickup",
    appliesTo: "Pickup",
    accessorialType: "Service Center",
    status: "Draft",
    autoAssign: "No",
    currency: "USD",
    createdDate: "10/15/2025",
    createdBy: "John Doe",
    shippingInstructionsCode: "5678",
    interlinerCharges: "Yes",
  },
  {
    id: 3,
    code: "BlindFee3",
    description: "Blind Shipment Fee",
    longDescription: "Blind Shipment Fee 3",
    serviceLevel: ["LTL"],
    rateConfiguration: "Rate per Unit",
    rateMinMax: "$1,699 ($3,699, $1,699)",
    appliesTo: "Delivery",
    accessorialType: "Global",
    status: "Active",
    autoAssign: "Yes",
    currency: "USD",
    createdDate: "09/20/2025",
    createdBy: "Jane Smith",
    shippingInstructionsCode: "9012",
    interlinerCharges: "No",
  },
];
